import api from './api';

const fetchOrganization = ({ id }) => api.get(`/api/organizations/${id}/`);
const listOrganizations = () => api.get('/api/organizations/');

export default {
  fetchOrganization,
  listOrganizations,
};
